<style scoped>

.row {
  display: flex;
  flex-direction: row;
}
.col {
  display: flex;
  flex-direction: column;
}
.center {
  display: flex;
  align-items: center;
}
.order-1 {
  order:1
}
.order-2 {
  order:2
}
.order-3 {
  order:3
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center; 
}
</style>
<style>
  .vertical-center-modal > .ivu-modal {
    top: 30% !important;
  }
  .vertical-center-modal > .ivu-modal > .ivu-modal-content > .ivu-modal-body {
    padding: 10px 16px 16px 16px !important;
  }
  .ico > .ivu-avatar-large {
    width:45px !important;
    height:45px !important;
    line-height:45px !important;
    border-radius:52% !important;
  }
  .ico > .ivu-avatar {
    /* background:rgb(51, 51, 51) !important; */
  }
</style>


<template>
  <Modal v-model="show"
    :footer-hide="true"
    :closable="false"
    class-name="vertical-center-modal">

    <div class="wrapper">
      <div class="header row center" style="justify-content:space-between;">
        <h3 class="order-1" >{{title.content}}</h3>
        <!-- <img class="order-2" alt=" " @click="dismiss($event)" style="height:25px;width:25px;" src="@/assets/close.png"> -->
      </div>      
      <div class="content row center" style="margin-top:15px">
        <div v-show="icon" class="order-1 ico col center" style="height:50px;width:20%;background-color:transparent;">
           <Avatar style="margin-left:-10px;" :icon="icon" size="large" />
        </div>
        <div class="order-2" style="height:auto;width:80%;">
          <p>{{message.content}}</p>
        </div>        
      </div>
      <div class="footer row" style="justify-content:flex-end;margin-top:20px;">
        <Button @click="doAction(item)" :type="item.type" v-for="(item,i) in buttons" :key="i" style="margin-left:5px;" >{{item.label}}</Button>
      </div>
    </div>

  </Modal>
</template>

<script>

// primary, info, success, warning, error
export default {
  name: 'index',
  data() {
    return {
      show:false,
      closable:true,
      type: 'default',
      durationInSec:0,
      title: {
        content:'', cssClass:''
      },
      message: {
        content:'', cssClass:''
      },
      icon: '', // help, alert, checkmark, ios-trash, ios-close
      buttons:[],
      closeBtn: {
        cssClass:'', style: {}
      }
    };
  },
  watch: {
    durationInSec: function() {
      if (this.durationInSec==0)  return;
      setTimeout(()=> { this.show=false; },this.durationInSec*1000);
    }
  },
  methods: {
    doAction(item) {      
      this.show=!item.hideAfter;
      item.action();
    },
    dismiss(event) {
      console.log('dismiss...');
      this.show = false;
    },
    notAllowTouchMove(event) {
      event.preventDefault();
    }
  }
}

</script>
